module.exports = __webpack_public_path__ + "img/header-trilha.88de2b29.png";